import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { IPublishedAnnouncementsResponse, IResidentAnnouncementContent } from '../../models';
import { announcementQueryV2, announcementsQueryV2 } from '../../queries';

@Injectable()
export class AnnouncementsFacade {
  constructor(private apollo: Apollo) {}

  public getAnnouncements(
    offset: number,
    limit: number
  ): Observable<IPublishedAnnouncementsResponse> {
    return this.apollo
      .query<{ publishedAnnouncementsV2: IPublishedAnnouncementsResponse }>({
        query: announcementsQueryV2,
        variables: {
          offset,
          limit,
        },
      })
      .pipe(map(response => response?.data?.publishedAnnouncementsV2));
  }

  public getAnnouncement(announcementId: string): Observable<IResidentAnnouncementContent> {
    return this.apollo
      .query<{ getAnnouncementV2: IResidentAnnouncementContent }>({
        query: announcementQueryV2,
        variables: {
          announcementId,
        },
      })
      .pipe(map(response => response?.data?.getAnnouncementV2));
  }
}
